/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/revokeCredential.config.json';
import notification from '../config/notifications.config.json';
import axios from 'axios';

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { RESEND_CREDENTIAL } from '../graphql';
import { VApplication } from '@/application';

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface IResendCredentialMethods extends IPluginMethodMap {
  getResendCredential(args: any): Promise<any>;
}

export interface ResendCredentialProps {
  id: string;
  sendToEmail: boolean;
  sendToWallet: boolean;
}

export class ResendCredentialService implements IAgentPlugin {
  readonly methods: IResendCredentialMethods;

  constructor() {
    this.methods = {
      getResendCredential: this.getResendCredential.bind(this),
    };
  }

  async getResendCredential(args: ResendCredentialProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    try {
      if (client) {
        let _thr =
          args?.sendToEmail && args?.sendToWallet
            ? 'BOTH'
            : args?.sendToEmail
            ? 'EMAIL'
            : args?.sendToWallet
            ? 'WALLET'
            : null;
        const res = await client.mutate({
          mutation: RESEND_CREDENTIAL,
          variables: {
            input: {
              id: args?.id,
              thr: _thr,
            },
          },
          fetchPolicy: 'no-cache',
        });
        if (res?.data?.resendCredential?.message) {
          return {
            notification: notification?.resendCredential,
          };
        }
      }
    } catch (err: any) {
      // console.log("error in revoke credential", err?.message);
      throw err;
    }
  }
}
